/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { State } from '@core/store';
import { getIsDriverActionPending } from '@drivers/store/drivers.selectors';
import { Store } from '@ngrx/store';
import { Driver, Vehicle } from '@shared/models';
import * as VehicleActions from '@vehicles/store/vehicles.actions';
import { getVehicles } from '@vehicles/store/vehicles.selectors';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-vehicles',
    templateUrl: './vehicles.component.html',
    styleUrls: ['./vehicles.component.scss'],
    standalone: false
})
export class VehiclesComponent implements OnInit {
  readonly tableColumns = [
    'description',
    'licensePlate',
    'licenseClass',
    'department',
    'actions'
  ];
  vehicles: Vehicle[] = [];
  dataSource: MatTableDataSource<Vehicle>;
  actionPending$: Observable<boolean>;
  tab = 0;

  constructor(
    private store: Store<State>,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.store.select(getVehicles).subscribe(vehicles => {
      this.vehicles = vehicles;
      this.onChangeTab(this.tab);
      this.changeDetectorRef.markForCheck();
    });
    this.actionPending$ = this.store.select(getIsDriverActionPending);
    this.store.dispatch(new VehicleActions.LoadVehicles());
  }

  onChangeTab(tab: number): void {
    this.tab = tab;
    if (tab === 0) {
      this.dataSource = new MatTableDataSource(this.vehicles.filter(vehicle => vehicle.enabled === true));
    } else {
      this.dataSource = new MatTableDataSource(this.vehicles.filter(vehicle => vehicle.enabled === false));
    }
  }

  editVehicle(vehicleId?: string): void {
    this.store.dispatch(new VehicleActions.LoadVehicle(vehicleId));
  }

  deactivateDriver(vehicle: Vehicle): void {
    this.store.dispatch(new VehicleActions.DeactivateVehicle(vehicle));
  }
}
